module.exports = __webpack_public_path__ + "static/IMG_1396-ff2f4aa8029051ee569cca53130c1a38.jpg";